import { render, staticRenderFns } from "./User-Rights.vue?vue&type=template&id=4223eb8c&"
import script from "./User-Rights.vue?vue&type=script&lang=js&"
export * from "./User-Rights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports